const TradeAccount = () => import('./components/TradeAccount');
Vue.component('TradeAccount', TradeAccount);
